import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import { observer, inject } from 'mobx-react'
import DataWrapper from '../../principal/containers/DataWrapper'
import { TabelaNotices } from '../components/TabelaNotices';
import NoticeStore from '../stores/NoticesStore';

@inject("store")
@DataWrapper
@observer
export default class Notices extends Component {
    constructor(props) {
        super(props)
        this.appStore = this.props.store.appStore
        this.tituloPaginaStore = this.props.store.tituloPaginaStore
        this.loginStore = this.props.store.loginStore
        this.controller = new NoticeStore()
    }

    can = (operacao = "C", tarefa = "Notices") => this.loginStore.can(tarefa, operacao)

    componentDidMount() {
        this.appStore.showTopbar(true)
        this.appStore.showVoltarTopBar(false)
        this.tituloPaginaStore.setTitulo("Avisos")
        this.controller.loadNotices()
    }

    render() {
        const { notices, columns } = this.controller
        return (
            <React.Fragment>
                <div className="form-wrapper">
                    <Container className="tela-botoes-inclusao-topo" fluid>
                        <Row className="botoes-inclusao-topo">
                            <Col xs={12} sm={12} md={12} >
                                {this.can("I") &&
                                    <Link className="btn-com-bordas-primary" to={`/notices/cadastro`}>Novo Aviso</Link>
                                }
                            </Col>
                        </Row>
                        <TabelaNotices notices={notices} columns={columns} />
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/notices/telas/Notices.js